import API from '@/org-app/api';
import { createGetOneAction, createPostAction, createPutAction } from '@/utils/ActionsUtils';

import * as types from './mutation-types';

const actions = {
  getPackageGroup: createGetOneAction(
    API.instance.getPackageGroup,
    types.GET_PACKAGE_GROUP,
    'messages.failedToGetPackageGroup',
    true,
  ),
  createPackageGroup: createPostAction(
    API.instance.postPackageGroup,
    types.SAVE_PACKAGE_GROUP,
    'messages.failedToSavePackageGroup',
  ),
  updatePackageGroup: createPutAction(
    API.instance.putPackageGroup,
    types.SAVE_PACKAGE_GROUP,
    'messages.failedToUpdatePackageGroup',
  ),
};

export default actions;
